import script from "./floatWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./floatWindow.vue?vue&type=script&setup=true&lang=js"

import "./floatWindow.vue?vue&type=style&index=0&id=299fcfbb&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-299fcfbb"]])

export default __exports__